(function () {
    'use strict';

    angular
        .module('sodCommon')
        .service('GaService', GaService);

    function GaService(lodash) { // eslint-disable-line no-unused-vars
        this.addEvent = function(options, model) {
            var ga_event = lodash.get(options, 'ga_event');
            if (!ga_event) return ;
            if (!model) model = {};
            var modelData = {};
            if (lodash.has(options, 'map')) {
                modelData = lodash.reduce(options.map, function(carry, value, key) {
                    carry[key] = lodash.get(model, value);
                    return carry;
                }, {});
            }
            var gaData = lodash.get(options, 'ga_data', {})
            gtag('event', ga_event, lodash.extend(gaData, modelData));
        };
    }
})();
